/**
 * Diploma and CV verification states, in the words each side reads them.
 *
 * Mirrors `VerificationStatus` in app/core/constants.py. The tones follow the
 * console-wide rule: waiting on someone is `warning`, finished well is
 * `success`, finished badly is `danger`, inert is `neutral`.
 */

export const DOCUMENT_TONES = {
  UNVERIFIED: 'neutral',
  PENDING: 'warning',
  VERIFIED: 'success',
  REJECTED: 'danger',
};

/** What a student sees on their own diploma or CV. */
export const STUDENT_DOCUMENT_LABELS = {
  UNVERIFIED: 'Not verified',
  PENDING: 'Awaiting check',
  VERIFIED: 'Verified',
  REJECTED: 'Not accepted',
};

/** What an admin sees in the review queue. */
export const ADMIN_DOCUMENT_LABELS = {
  UNVERIFIED: 'Not asked',
  PENDING: 'Pending',
  VERIFIED: 'Verified',
  REJECTED: 'Rejected',
};

/**
 * What a student sees on a certificate on their Skills page. Not submitted
 * rather than Not verified: until a file is uploaded there is nothing to check.
 */
export const STUDENT_CERTIFICATE_LABELS = {
  UNVERIFIED: 'Not submitted',
  PENDING: 'Pending review',
  VERIFIED: 'Verified',
  REJECTED: 'Rejected',
};

/** What a diploma upload accepts. The server enforces the same limits. */
export const DIPLOMA_MAX_SIZE = 5 * 1024 * 1024;
export const DIPLOMA_ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
export const DIPLOMA_HINT = 'PDF, JPEG or PNG · max 5 MB';

/** A course or professional certificate is accepted exactly as a diploma is. */
export const CERTIFICATE_MAX_SIZE = DIPLOMA_MAX_SIZE;
export const CERTIFICATE_ACCEPT = DIPLOMA_ACCEPT;
export const CERTIFICATE_HINT = DIPLOMA_HINT;
